import posthog from 'posthog-js';
import { PostHogProvider as NaturalPostHogProvider } from 'posthog-js/react';
import { type FC, type PropsWithChildren, useEffect } from 'react';

import { DEPLOYMENT_TIER, POSTHOG_HOST, POSTHOG_KEY, VERSION } from '@/configuration/client';
import { useUser } from '@/hooks';
import useUserProfile from '@/providers/Auth/useUserProfile';

if (POSTHOG_HOST && POSTHOG_KEY) {
  posthog.init(POSTHOG_KEY, {
    api_host: '/ph',
    defaults: '2025-11-30',
    ui_host: POSTHOG_HOST,
  });
}

export const PostHogProvider: FC<PropsWithChildren> = ({ children }) => {
  const [user] = useUser();
  const profile = useUserProfile();

  const userId = user?.id || null;
  const isOnBehalfOf = user?.isOnBehalfOf ?? false;

  useEffect(() => {
    if (POSTHOG_HOST && POSTHOG_KEY) {
      if (userId && profile) {
        posthog.identify(userId, {
          ...profile,
          env: DEPLOYMENT_TIER,
          internal: !!profile?.email?.endsWith('@glade.ai'),
          isOnBehalfOf,
          version: VERSION,
        });
      }
    }
  }, [userId, isOnBehalfOf, profile]);

  return <NaturalPostHogProvider client={posthog}>{children}</NaturalPostHogProvider>;
};
